import { defineMessages } from 'react-intl';

export default defineMessages({
  dateEcheance: {
    id: 'dashboard_auto.mes_contracts.date_echeance',
  },
  numPolice: {
    id: 'dashboard_auto.mes_contracts.num_police',
  },
  voirTous: {
    id: 'dashboard_auto.mes_contracts.voir_tous',
  },
  Actif: {
    id: 'dashboard_auto.mes_contracts.actif',
  },
  Encours: {
    id: 'dashboard_auto.mes_contracts.encours',
  },
  Formule: {
    id: 'dashboard_MRH.mes_contracts.formule',
  },
  dateEffet: {
    id: 'dashboard_EPARGN.mes_contracts.date_effet',
  },
  NumContract: {
    id: 'dashboard_EPARGN.mes_contracts.num_contract',
  },
  indetifiant: {
    id: 'dashboard_sante_international.mes_contracts.indetifiant',
  },
  seeDetails: {
    id: 'dashboard_auto.last_sinister.see_details',
  },
  epargnConstitue: {
    id: 'dashboard_epargn.epargn_constitue',
  },
  tauxMinimum: {
    id: 'dashboard_epargn.taux_minimum',
  },
  SituationEpargn: {
    id: 'dashboard_epargn.situation_au',
  },
  capitalGaranti: {
    id: 'dashboard_epargn.epargn_capital_garanti',
  },
});
